import { Component } from '@angular/core';
import { LegacyWidgetComponentBase } from '../widget.class';

@Component({
  selector: 'legacy-app-widget-oxygen',
  templateUrl: './widget-oxygen.component.html',
  styleUrls: ['./widget-oxygen.component.scss'],
})
export class WidgetOxygenComponent extends LegacyWidgetComponentBase {}
